import { FC, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

import { ActionProperties } from "../../../../page-actions";
import { DesignEvent } from "../../../../../base/models";
import { DeviceType } from "./ToggleDeviceButtonGroup";
import { IPage } from "../../../models";
import { PageActionsToolbar } from "./PageActionsToolbar";
import { PageActionsViewSwitch } from "./PageActionsViewSwitch";
import { ResponsiveCanvas } from "./ResponsiveCanvas";
import { useDesignContext } from "../../../../../providers";

interface IPageActionsDesignerProps {
    page: IPage,
    onDesignChange: (event: DesignEvent) => void
}

export const PageActionsDesigner: FC<IPageActionsDesignerProps> = ({
    page, onDesignChange
}) => {
    const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.Desktop);
    const { action: { element: action, dataSource, designerMode, setEditMode } } = useDesignContext()

    const getCanvasWithToolbar = () => {
        return <>
            <PageActionsToolbar
                editMode={designerMode}
                onEditModeChange={setEditMode}
                deviceType={deviceType}
                onDeviceTypeChange={setDeviceType} />
            <ResponsiveCanvas deviceType={deviceType}>
                <PageActionsViewSwitch
                    editMode={designerMode}
                    page={page}
                    onDesignChange={onDesignChange} />
            </ResponsiveCanvas>
        </>
    }

    const getActionProps = () => {
        if (!action)
            return <></>

        return <div className="h-100">
            <ActionProperties
                action={action}
                dataSource={dataSource}
                onDesignChange={onDesignChange} />
        </div>
    }

    const getDesignerBody = () => {
        if (!action)
            return <>{getCanvasWithToolbar()}</>

        return <>
            <PanelGroup direction="horizontal">
                <Panel defaultSize={75} minSize={75}>
                    {getCanvasWithToolbar()}
                </Panel>
                <PanelResizeHandle />
                <Panel defaultSize={25} maxSize={25}>
                    {getActionProps()}
                </Panel>
            </PanelGroup>
        </>
    }

    return <div className='position-relative designer-box'>
        {getDesignerBody()}
    </div>
}

